"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 3,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function PromotionalSliderConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="w-full h-[400px] bg-muted/50 animate-pulse flex items-center justify-center">
        <span className="text-muted-foreground font-default">Cargando promociones...</span>
      </div>;
  }
  if (error || !products || products.length === 0) {
    return null;
  }
  return <Carousel opts={{
    loop: true,
    align: "start"
  }} className="w-full relative">
      <CarouselContent>
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i}>
            <div className="bg-accent/30 w-full py-12 px-6 md:px-16 lg:px-24 flex flex-col lg:flex-row items-center justify-between gap-12 relative overflow-hidden min-h-[450px]">
              
              {}
              <div className="flex flex-col items-center lg:items-start gap-6 z-10 text-center lg:text-left flex-1">
                <div className="flex items-center gap-8 mb-4">
                  <Link to="/HomePage#">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_logo.png" alt="Kalisch Acero" className="h-8 md:h-10 object-contain" />
                  </Link>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/voller_logo.png" alt="Voller" className="h-8 md:h-10 object-contain" />
                </div>
                <div className="space-y-2">
                  <p className="text-primary font-default font-bold text-xl md:text-2xl uppercase tracking-tight">
                    En la compra de
                  </p>
                  <h2 className="text-secondary font-default font-bold text-3xl md:text-5xl lg:text-6xl uppercase max-w-xl leading-tight">
                    {product.title}
                  </h2>
                </div>
              </div>

              {}
              <div className="flex flex-col items-center z-10 flex-shrink-0">
                <p className="text-primary font-default font-bold text-xl md:text-2xl uppercase tracking-tight mb-2">
                  A solo
                </p>
                <div className="flex items-start text-chart-2 font-default font-bold leading-none">
                  <span className="text-4xl md:text-5xl mt-2 md:mt-4">$</span>
                  <span className="text-7xl md:text-9xl tracking-tighter">
                    {product.price?.toLocaleString("es-MX") || "0"}
                  </span>
                </div>
                <div className="mt-8 w-full max-w-[250px]">
                  <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full py-6 text-lg font-bold shadow-lg w-full" text="Agregar al carrito" showQuantity={false} />
                </div>
              </div>

              {}
              <div className="relative z-10 flex-shrink-0 mt-8 lg:mt-0 flex justify-center lg:justify-end flex-1">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-64 md:w-80 lg:w-96 object-contain drop-shadow-2xl" /> : <div className="w-64 h-64 bg-muted rounded-lg flex items-center justify-center">
                    <span className="text-muted-foreground">Sin imagen</span>
                  </div>}
                
                {}
                <div className="absolute -top-6 -right-6 md:-top-10 md:-right-10 bg-chart-2 text-white rounded-lg w-32 h-32 md:w-40 md:h-40 flex flex-col items-center justify-center text-center p-4 shadow-xl transform rotate-12 border-4 border-white">
                  <span className="font-default font-bold text-lg md:text-xl leading-tight uppercase">
                    Llévate<br />Gratis
                  </span>
                  <div className="w-12 h-0.5 bg-white/50 my-1 md:my-2"></div>
                  <span className="text-xs md:text-sm font-medium">
                    Regalo Sorpresa
                  </span>
                </div>
              </div>

            </div>
          </CarouselItem>)}
      </CarouselContent>
      
      {}
      <div className="hidden md:block">
        <CarouselPrevious className="left-4 lg:left-8 bg-foreground text-background hover:bg-foreground/90 hover:text-background border-none size-12 shadow-lg" />
        <CarouselNext className="right-4 lg:right-8 bg-foreground text-background hover:bg-foreground/90 hover:text-background border-none size-12 shadow-lg" />
      </div>
    </Carousel>;
}
function StatsSection() {
  const stats = [{
    value: "46",
    label: "Años"
  }, {
    value: "42",
    label: "Sucursales"
  }, {
    value: "20",
    label: "Ciudades"
  }, {
    value: "8",
    label: "Estados"
  }, {
    value: "2",
    label: "Países"
  }];
  return <div className="relative bg-foreground py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/construction_site_dark_bg.png)] bg-cover bg-center opacity-20 mix-blend-luminosity"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center">
              <span className="text-5xl md:text-6xl lg:text-7xl font-default font-bold text-background mb-4 tracking-tight">
                {stat.value}
              </span>
              <div className="h-0.5 w-16 bg-background/40 mb-4"></div>
              <span className="text-background/90 text-sm md:text-base font-medium uppercase tracking-[0.2em]">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}
export default function PromotionalSlider() {
  return <section id="promotional-slider" className="w-full bg-background flex flex-col">
      <EcommerceProductsProvider wp_query={{
      per_page: 3,
      orderby: "date",
      order: "desc"
    }}>
        <PromotionalSliderConsumer />
      </EcommerceProductsProvider>
      <StatsSection />
    </section>;
}